export default __webpack_public_path__ + "static/media/excelstep4.3269a257.png";